import { EndpointModulesStatusDetailsWebComponent } from './component/EndpointModulesStatusDetailsWebComponent';
import { WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS_DETAILS } from '../../webcomponents.constants';

export { EndpointModulesStatusDetailsWebComponent };

window.customElements.define(
  WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS_DETAILS,
  EndpointModulesStatusDetailsWebComponent
);
